export const fieldNameInput: IFieldNameInput = {
    insuranceContractNumber: "insuranceContractNumber",
    bornPeopleBuyInsurance:"bornPeopleBuyInsurance",
    bornPeopleUseInsurance:"bornPeopleUseInsurance",
    documentPerson:"documentPerson"
}
interface IFieldNameInput {
    insuranceContractNumber:"insuranceContractNumber",
    bornPeopleBuyInsurance:"bornPeopleBuyInsurance",
    bornPeopleUseInsurance:"bornPeopleUseInsurance",
    documentPerson:"documentPerson"
}